import { render, staticRenderFns } from "./QuickMenuCollection.vue?vue&type=template&id=c37e494e&scoped=true&"
import script from "./QuickMenuCollection.vue?vue&type=script&lang=js&"
export * from "./QuickMenuCollection.vue?vue&type=script&lang=js&"
import style0 from "./QuickMenuCollection.vue?vue&type=style&index=0&id=c37e494e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37e494e",
  null
  
)

export default component.exports